import React from 'react';

import { cn } from '../../utils/classname';
import './color-label.scss';

type ColorLabelProps = {
  backgroundColor: string;
  size?: string;
};

export const ColorLabel: React.FC<ColorLabelProps> = ({ backgroundColor, size, children }) => {
  const classes = cn('rc-color-label', `rc-color-label--size-${size}`);
  return (
    <span className={classes} style={{ backgroundColor: backgroundColor }}>
      {children}
    </span>
  );
};

ColorLabel.defaultProps = {
  size: 'large'
};
